export default "__VITE_ASSET__CrsyOHUV__"